import { Media, Product } from '@gripp/shared-logic';
import { MediaListItem } from '@gripp/shared-ui';
import { ProductFileItemMenu } from './productFileItemMenu';

type Props = {
  product?: Product;
  media: Media;
  invalidateQuery: () => void;
};

export const ProductFileItem = ({ product, media, invalidateQuery }: Props) => {
  return (
    <MediaListItem
      media={media}
      invalidateQuery={invalidateQuery}
      menu={
        product && (
          <ProductFileItemMenu
            product={product}
            media={media}
            invalidateQuery={invalidateQuery}
          />
        )
      }
    />
  );
};
